<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div v-if="isLoading"><Loader /></div>
        <units-table 
          :units="units"
          :refresh="fetchData" 
          :searchQuery="searchTerm"
          v-else />
      </div>
    </div>
  </div>
</template>

<script>
import UnitsTable from "./components/UnitTable.vue";
import Loader from "./components/Loader.vue";
import { fetchUnits } from "../api/services/inventory";
import { ElLoading } from "element-plus";
import { ref } from "vue";

const isLoading = ref(false);
const units = ref([]);
const searchTerm = ref([]);

export default {
  name: "units",
  components: {
    UnitsTable,
    Loader,
  },
  setup() {
    const fetchData = async (search, page) => {
      searchTerm.value = search;
      isLoading.value = true;
      try {
        const response = await fetchUnits(search, page);
        units.value = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fullScreenLoader = () => {
      ElLoading.service({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    };

    return {
      fullScreenLoader,
      fetchData,
      units,
      isLoading,
      searchTerm
    };
  },
  mounted() {
    this.fetchData("", 1);
  },
};
</script>
